export const types = {
    GET_CURRENT_USER_TALENT_PROFILE: 'GET_CURRENT_USER_TALENT_PROFILE',
    GET_CURRENT_USER_TALENT_PROFILE_SUCCESS: 'GET_CURRENT_USER_TALENT_PROFILE_SUCCESS',
    GET_CURRENT_USER_TALENT_PROFILE_FAIL: 'GET_CURRENT_USER_TALENT_PROFILE_FAIL',

    GET_TALENT_PROFILE_DETAILS: 'GET_TALENT_PROFILE_DETAILS',
    GET_TALENT_PROFILE_DETAILS_SUCCESS: 'GET_TALENT_PROFILE_DETAILS_SUCCESS',
    GET_TALENT_PROFILE_DETAILS_FAIL: 'GET_TALENT_PROFILE_DETAILS_FAIL',

    GET_ALL_TALENT_PROFILES: 'GET_ALL_TALENT_PROFILES',
    GET_ALL_TALENT_PROFILES_SUCCESS: 'GET_ALL_TALENT_PROFILES_SUCCESS',
    GET_ALL_TALENT_PROFILES_FAIL: 'GET_ALL_TALENT_PROFILES_FAIL',
    RESET_TALENT_PROFILE: 'RESET_TALENT_PROFILE',
    CREATE_TALENT_PROFILE: 'CREATE_TALENT_PROFILE',
    CREATE_TALENT_PROFILE_SUCCESS: 'CREATE_TALENT_PROFILE_SUCCESS',
    CREATE_TALENT_PROFILE_FAIL: 'CREATE_TALENT_PROFILE_FAIL',

    UPDATE_TALENT_PROFILE: 'UPDATE_TALENT_PROFILE',
    UPDATE_TALENT_PROFILE_SUCCESS: 'UPDATE_TALENT_PROFILE_SUCCESS',
    UPDATE_TALENT_PROFILE_FAIL: 'UPDATE_TALENT_PROFILE_FAIL',

    PUBLISH_TALENT_PROFILE: 'PUBLISH_TALENT_PROFILE',
    PUBLISH_TALENT_PROFILE_SUCCESS: 'PUBLISH_TALENT_PROFILE_SUCCESS',
    PUBLISH_TALENT_PROFILE_FAIL: 'PUBLISH_TALENT_PROFILE_FAIL',

    UNPUBLISH_TALENT_PROFILE: 'UNPUBLISH_TALENT_PROFILE',
    UNPUBLISH_TALENT_PROFILE_SUCCESS: 'UNPUBLISH_TALENT_PROFILE_SUCCESS',
    UNPUBLISH_TALENT_PROFILE_FAIL: 'UNPUBLISH_TALENT_PROFILE_FAIL',

    DELETE_TALENT_PROFILE: 'DELETE_TALENT_PROFILE',
    DELETE_TALENT_PROFILE_SUCCESS: 'DELETE_TALENT_PROFILE_SUCCESS',
    DELETE_TALENT_PROFILE_FAIL: 'DELETE_TALENT_PROFILE_FAIL',

    DELETE_SINGLE_TALENT_IMAGE: 'DELETE_SINGLE_TALENT_IMAGE',
    DELETE_SINGLE_TALENT_IMAGE_SUCCESS: 'DELETE_SINGLE_TALENT_IMAGE_SUCCESS',
    DELETE_SINGLE_TALENT_IMAGE_FAIL: 'DELETE_SINGLE_TALENT_IMAGE_FAIL',

    DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY: 'DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY',
    DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY_SUCCESS: 'DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY_SUCCESS',
    DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY_FAIL: 'DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY_FAIL',

    UPLOAD_IMAGE: 'UPLOAD_IMAGE',
    UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
    UPLOAD_IMAGE_FAIL: 'UPLOAD_IMAGE_FAIL',

    GET_TALENT_PAST_WORK: 'GET_TALENT_PAST_WORK',
    GET_TALENT_PAST_WORK_SUCCESS: 'GET_TALENT_PAST_WORK_SUCCESS',
    GET_TALENT_PAST_WORK_FAIL: 'GET_TALENT_PAST_WORK_FAIL',

    SET_PROFILE_FOR_EDIT: 'SET_PROFILE_FOR_EDIT',

    ADD_TALENT_FILTER: 'ADD_TALENT_FILTER',
    REMOVE_TALENT_FILTER: 'REMOVE_TALENT_FILTER',

    TOGGLE_TALENT_FILTER: 'TOGGLE_TALENT_FILTER',

    FILTER_TALENT: 'FILTER_TALENT',
    FILTER_TALENT_SUCCESS: 'FILTER_TALENT_SUCCESS',
    FILTER_TALENT_FAIL: 'FILTER_TALENT_FAIL',

    GET_DISCOVER: 'GET_DISCOVER',
    GET_DISCOVER_SUCCESS: 'GET_DISCOVER_SUCCESS',
    GET_DISCOVER_FAIL: 'GET_DISCOVER_FAIL',

    GET_ACTS: 'GET_TALENT_ACTS',
    GET_ACTS_SUCCESS: 'GET_TALENT_ACTS_SUCCESS',
    GET_ACTS_FAIL: 'GET_TALENT_ACTS_FAIL',

    GET_SINGLE_ACT: 'GET_SINGLE_ACT',
    GET_SINGLE_ACT_SUCCESS: 'GET_SINGLE_ACT_SUCCESS',
    GET_SINGLE_ACT_FAIL: 'GET_SINGLE_ACT_FAIL',

    CREATE_ACT: 'CREATE_ACT_INITIAL',
    CREATE_ACT_SUCCESS: 'CREATE_ACT_CREATE_ACT_INITIAL_SUCCESS',
    CREATE_ACT_FAIL: 'CREATE_ACT_CREATE_ACT_INITIAL_FAIL',

    DELETE_ACT: 'DELETE_INITIAL_ACT',
    DELETE_ACT_SUCCESS: 'DELETE_ACT_INITIAL_SUCCESS',
    DELETE_ACT_FAIL: 'DELETE_ACT_INITIAL_FAIL',

    UPDATE_ACT: 'UPDATE_INITIAL_ACT',
    UPDATE_ACT_SUCCESS: 'UPDATE_ACT_INITIAL_SUCCESS',
    UPDATE_ACT_FAIL: 'UPDATE_ACT_INITIAL_FAIL',

    GET_MY_ACTS: 'GET_MY_INITIAL_ACTS',
    GET_MY_ACTS_SUCCESS: 'GET_MY_ACTS_INITIAL_SUCCESS',
    GET_MY_ACTS_FAIL: 'GET_MY_ACTS_INITIAL_FAIL',
    SET_TALENT_DETAILS: 'SET_TALENT_DETAILS',

    GET_TALENT_REVIEWS: 'GET_TALENT_REVIEWS',
    GET_TALENT_REVIEWS_SUCCESS: 'GET_TALENT_REVIEWS_SUCCESS',
    GET_TALENT_REVIEWS_FAIL: 'GET_TALENT_REVIEWS_FAIL',

    CREATE_TALENT_REVIEW: 'CREATE_TALENT_REVIEW',
    CREATE_TALENT_REVIEW_SUCCESS: 'CREATE_TALENT_REVIEW_SUCCESS',
    CREATE_TALENT_REVIEW_FAIL: 'CREATE_TALENT_REVIEW_FAIL',

    UPDATE_TALENT_REVIEW: 'UPDATE_TALENT_REVIEW',
    UPDATE_TALENT_REVIEW_SUCCESS: 'UPDATE_TALENT_REVIEW_SUCCESS',
    UPDATE_TALENT_REVIEW_FAIL: 'UPDATE_TALENT_REVIEW_FAIL',

    DELETE_TALENT_REVIEW: 'DELETE_TALENT_REVIEW',
    DELETE_TALENT_REVIEW_SUCCESS: 'DELETE_TALENT_REVIEW_SUCCESS',
    DELETE_TALENT_REVIEW_FAIL: 'DELETE_TALENT_REVIEW_FAIL',

    LIKE_TALENT_REVIEW: 'LIKE_TALENT_REVIEW',
    LIKE_TALENT_REVIEW_SUCCESS: 'LIKE_TALENT_REVIEW_SUCCESS',
    LIKE_TALENT_REVIEW_FAIL: 'LIKE_TALENT_REVIEW_FAIL',

    DISLIKE_TALENT_REVIEW: 'DISLIKE_TALENT_REVIEW',
    DISLIKE_TALENT_REVIEW_SUCCESS: 'DISLIKE_TALENT_REVIEW_SUCCESS',
    DISLIKE_TALENT_REVIEW_FAIL: 'DISLIKE_TALENT_REVIEW_FAIL',

    ADD_CREDIT: 'ADD_CREDIT',
    ADD_CREDIT_SUCCESS: 'ADD_CREDIT_SUCCESS',
    ADD_CREDIT_FAIL: 'ADD_CREDIT_FAIL',

    UPDATE_CREDIT: 'UPDATE_CREDIT',
    UPDATE_CREDIT_SUCCESS: 'UPDATE_CREDIT_SUCCESS',
    UPDATE_CREDIT_FAIL: 'UPDATE_CREDIT_FAIL',

    DELETE_CREDIT: 'DELETE_CREDIT',
    DELETE_CREDIT_SUCCESS: 'DELETE_CREDIT_SUCCESS',
    DELETE_CREDIT_FAIL: 'DELETE_CREDIT_FAIL',
};

export interface IAddCredit {
    title: string;
    type: string;
    role: string[];
    year: string;
    link: string;
    company: string;
    description: string;
    profileId: string;
}

export interface IGetTalentReviews {
    /** The Id of the current talent in focus */
    talentId: string;
    page?: number;
    limit?: number;
    cache?: string | string[];
}

export interface ICreateWorkProfile {
    body: {
        about?: string;
        age_from?: number;
        age_to?: number;
        audio_reel?: string;
        body_type?: string;
        demo_reel?: string;
        ethnicity?: string[];
        gender?: string;
        hair_color?: string;
        hair_type?: string[];
        height?: string;
        language_spoken?: string[];
        location?: { address: string; coordinates: [number, number]; description: string; short_name: string }[];
        other_skills?: { skill: string; expertise: string; years_of_experience: number; description: string }[];
        profile_type: string;
        skills?: { skill: string; expertise: string; years_of_experience: number; description: string }[];
        stage_name?: string;
        weight?: string;
    };
    uploads: {
        photos?: File[];
        profile_picture?: File[];
        feature_picture?: File[];
    };
}

export interface IUpdateWorkProfile extends Partial<ICreateWorkProfile> {
    id: string;
    fromCreate?: boolean;
    cache?: string | string[];
}

export interface ICreateTalentReview {
    review_subject: string;
    review_text: string;
    talent: string;
    rating: number;
    cache?: string | string[];
}

export interface IUpdateTalentReview {
    id: string;
    review_subject?: string;
    review_text?: string;
    rating?: number;
    cache?: string | string[];
}

export interface ILikeDislikeReview {
    reviewId: string;
    type: 'like' | 'dislike';
    cache?: string | string[];
}
